/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateAuthRefreshTokenRequest — dark-roast DTO: AuthPostRefreshTokenDto */
export const createAuthRefreshTokenRequestSchema = z.object({ "token": z.string().min(1) });
export type CreateAuthRefreshTokenRequest = z.infer<typeof createAuthRefreshTokenRequestSchema>;
